import { DateTime } from "luxon";
import { ReactNode, createContext, useContext, useEffect, useState } from "react";

import { DateContext } from "@/types/providers";

const context = createContext<DateContext>(null);

export const DateContextProvider = ({ children }: { children: ReactNode }) => {
    const [selectedDate, setSelectedDate] = useState(DateTime.now().plus({ days: 1 }));

    useEffect(() => {
        if (!selectedDate.isValid) {
            setSelectedDate(DateTime.now().plus({ days: 1 }));
        }
    }, [selectedDate]);

    return (
        <context.Provider
            value={{
                selectedDate,
                setSelectedDate,
            }}
        >
            {children}
        </context.Provider>
    );
};

const useDateContext = () => {
    const ctx = useContext(context);
    if (!ctx) {
        throw new Error("useDateContext must be used within a DateContextProvider");
    } else {
        return ctx;
    }
};

export default useDateContext;
